<ng-template #searchCreateDeal>
	<cds-search (valueChange)="searchDeal($event)" [expandable]="false" size="lg"></cds-search>
	<button [size]="'lg'" (click)="this.httpService.reloadUserData()" cdsButton="secondary">
		Refresh Status
		<svg class="cds--btn__icon" cdsIcon="reset--alt" size="16"></svg>
	</button>
	<button size="lg" (click)="this.syncService.updatePage('create-fund')" cdsButton="primary">
		Create Fund
		<svg class="cds--btn__icon" cdsIcon="folder--add" size="16"></svg>
	</button>
</ng-template>

<ng-template #dealOverflowMenu let-actionData>
	<ibm-icon-button *ngIf="this.hoveringOverItem === actionData['Deal Name']" (click)="onClickUploadFiles(actionData['Deal Name'])" type="button" kind="ghost" description="Upload Files" align="bottom" style="z-index: 0">
		<svg class="cds--btn__icon" cdsIcon="document--add" size="16"></svg>
	</ibm-icon-button>

	<ibm-icon-button *ngIf="this.hoveringOverItem === actionData['Deal Name']" (click)="viewFiles(actionData)" type="button" kind="ghost" description="View Files" align="bottom" style="z-index: 0">
		<svg class="cds--btn__icon" cdsIcon="version" size="16"></svg>
	</ibm-icon-button>

	<ibm-icon-button *ngIf="this.hoveringOverItem === actionData['Deal Name']" (click)="this.httpService.downloadFiles(userData['Workspace'], actionData['Deal Name'])" type="button" kind="ghost" description="Download Files" align="bottom" style="z-index: 0">
		<svg class="cds--btn__icon" cdsIcon="download" size="16"></svg>
	</ibm-icon-button>

	<ibm-icon-button *ngIf="this.hoveringOverItem === actionData['Deal Name']" (click)="this.openDealEditModal(actionData['Deal Name'])" type="button" kind="ghost" description="Edit Fund" align="bottom" style="z-index: 0">
		<svg class="cds--btn__icon" cdsIcon="edit" size="16"></svg>
	</ibm-icon-button>

<!--	<ibm-icon-button *ngIf="this.hoveringOverItem === actionData['Deal Name']" (click)="this.submitDeal(actionData['Deal Name'])" type="button" kind="ghost" description="Start Pricing" align="bottom" style="z-index: 0">-->
<!--		<img *ngIf="this.theme === 'white'" class="cds&#45;&#45;btn__icon" src="assets/images/pricing&#45;&#45;quick-proposal-dark.svg" alt="Start Pricing Icon" width="16" height="16">-->
<!--		<img *ngIf="this.theme !== 'white'" class="cds&#45;&#45;btn__icon" src="assets/images/pricing&#45;&#45;quick-proposal-light.svg" alt="Start Pricing Icon" width="16" height="16">-->
<!--	</ibm-icon-button>-->

	<ibm-icon-button *ngIf="this.hoveringOverItem === actionData['Deal Name']" (click)="openDealDeletionModal(actionData['Deal Name'])" type="button" kind="ghost" description="Delete Deal" align="bottom-right" style="z-index: 0">
		<svg class="cds--btn__icon" cdsIcon="trash-can" size="16"></svg>
	</ibm-icon-button>
</ng-template>

<div @fadeInUp class="deals-container">
	<cds-contained-list [action]="searchCreateDeal" label="Deals">
<!--		<cds-contained-list-item *ngFor="let deal of displayDeals; let i = index" [clickable]="true" (click)="aggregateDeal(deal)" (mouseenter)="enteringContainedListItem(deal['Deal Name'])" [action]="dealOverflowMenu" [actionData]="deal">-->
		<cds-contained-list-item *ngFor="let deal of displayDeals; let i = index" [clickable]="true" (click)="viewFiles(deal)" (mouseenter)="enteringContainedListItem(deal['Deal Name'])" [action]="dealOverflowMenu" [actionData]="deal">
			<ng-container style="padding: 0" ibmContainedListItemButton>
				<div class="row" style="display: flex; margin: 0 !important">
					<div style="width: 32px !important; height: 16px; margin-top: -5.25px; padding: 0">
						<cds-inline-loading [state]="checkDealStatus(deal)">
						</cds-inline-loading>
					</div>
					<div style="width: calc(100% - 32px)">
						<span>{{deal['Deal Name']}}</span>
					</div>
				</div>
			</ng-container>
		</cds-contained-list-item>
	</cds-contained-list>
</div>
